import { Typography } from '@mui/material';

const ItemLabel = ({ children, label, text }) => (
    <Typography variant="body1" fontWeight="medium">
        {(text || children) && <span> {typeof label === 'string' ? label.replace(/:$/, '') : label}:&nbsp;</span>}
        {text
            ? <Typography component="span">{text}</Typography>
            : <>{children}</>
        }
    </Typography>
);

export default ItemLabel;
